module.exports = ".validationerrors-header {\n  font-weight: bold;\n  overflow-x: hidden; }\n\n.validationerrors-block:not(:last-child) .row:last-child {\n  border-bottom: 1px solid lightgray; }\n\n.validationerrors-headers {\n  margin-top: -10px;\n  border-bottom: 1px solid lightgray; }\n\n.validationerrors-block.odd .row {\n  background-color: #f8f8f8; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/validationerrors/validationerrors.component.scss
// module id = ./src/app/shared/validationerrors/validationerrors.component.scss
// module chunks = main